<mat-sidenav-container class="sidenav-container" autosize>
    <mat-sidenav #sidenav class="sidenav" [class.collapsed]="!isExpanded" [mode]="'side'" [opened]="true" [style.width]="isExpanded ? '260px' : '80px'">
      <div class="sidenav-inner">
        <div class="sidenav-gradient-overlay"></div>
        
        <!-- Top header/logo inside the sidenav -->
        <div class="sidenav-top">
          <span class="brand-name">Grooves Dental</span>
          <span class="brand-tagline" *ngIf="isExpanded">Dental Design System</span>
          <span class="brand-tagline uat-badge" *ngIf="uat && isExpanded">UAT Environment</span>
        </div>
        
        <!-- Navigation Links -->
        <mat-nav-list class="nav-list">
          <a mat-list-item 
             *ngFor="let sidebarLink of visibleSidebarLinks; let i = index"
             [routerLink]="sidebarLink.href" 
             class="sidebar-link" 
             routerLinkActive="active"
             [style.animation-delay]="(i * 50) + 'ms'">
            <div class="link-indicator"></div>
            <div class="link-content">
              <div class="icon-wrapper">
                <mat-icon>{{ sidebarLink.icon }}</mat-icon>
              </div>
              <span class="link-text" *ngIf="isExpanded">{{ sidebarLink.name }}</span>
            </div>
            <div class="link-hover-bg"></div>
          </a>
        </mat-nav-list>
        
        <!-- Sidenav Footer -->
        <div class="sidenav-footer">
          <div class="footer-decoration"></div>
          <span class="version-text" *ngIf="isExpanded">v2.0</span>
        </div>
      </div>
    </mat-sidenav>
  
    <mat-sidenav-content class="main-content">
      <!-- Enhanced Navbar -->
      <mat-toolbar class="navbar" sticky>
        <div class="navbar-left">
          <button mat-icon-button class="menu-toggle" (click)="toggleSidenav()">
            <mat-icon class="menu-icon" [class.rotated]="!isExpanded">
              {{ isExpanded ? 'chevron_left' : 'menu' }}
            </mat-icon>
          </button>

          <!-- Sub-navigation links based on current route -->
          <div class="sub-nav" *ngIf="productToolbar.includes(router.url)">
            <button mat-button routerLink="process">Process</button>
            <button mat-button routerLink="category">Category</button>
            <button mat-button routerLink="jobchecklist">Job Check List</button>
            <button mat-button routerLink="shipment">Shipment</button>
            <button mat-button routerLink="hsn">HSN</button>
            <button mat-button routerLink="pricelist">Price List</button>
          </div>
          <div class="sub-nav" *ngIf="doctorToolbar.includes(router.url)">
            <button mat-button routerLink="state">State</button>
            <button mat-button routerLink="area">City</button>
          </div>
          <div class="sub-nav" *ngIf="jobOrderToolbar.includes(router.url)">
            <button mat-button routerLink="remark">Remark</button>
          </div>
          <div class="sub-nav" *ngIf="productionToolbar.includes(router.url)">
            <button mat-button routerLink="employeelogin/in">Job In Details</button>
            <button mat-button routerLink="employeelogin/out">Job Out Details</button>
          </div>
          <div class="sub-nav" *ngIf="invoicingToolbar.includes(router.url)">
            <button mat-button routerLink="proforma">Proforma</button>
            <button mat-button routerLink="invoice">Invoice</button>
            <button mat-button routerLink="account">Account</button>
            <button mat-button routerLink="account_receipt">Account Receipt</button>
            <button mat-button routerLink="note">Credit/Debit Note</button>
            <button mat-button routerLink="journal_voucher">Journal Voucher</button>
            <button mat-button routerLink="knock_off">Knock Off</button>
          </div>
          <div class="sub-nav" *ngIf="challanToolbar.includes(router.url)">
            <button mat-button routerLink="challan">Challan</button>
          </div>
          <div class="sub-nav" *ngIf="companyToolbar.includes(router.url)">
            <button mat-button routerLink="employee">Employee Details</button>
            <button mat-button routerLink="department">Department</button>
          </div>
          <div class="sub-nav" *ngIf="accessToolbar.includes(router.url)">
            <button mat-button routerLink="userrole">User Roles</button>
            <button mat-button routerLink="auth">Users</button>
          </div>
        </div>
        
        <span class="spacer"></span>
        
        <div class="navbar-right">
          <!-- Help Button -->
          <app-help-button></app-help-button>

          <!-- Theme Toggle -->
          <app-theme-toggle></app-theme-toggle>
          
          <!-- User Menu -->
          <button mat-icon-button 
                  class="user-avatar-btn" 
                  [matMenuTriggerFor]="userMenu" 
                  aria-label="User menu">
            <div class="avatar-circle">
              <mat-icon>person</mat-icon>
            </div>
          </button>
          <mat-menu #userMenu="matMenu" class="user-menu-panel">
            <div class="menu-header">
              <div class="menu-avatar">
                <mat-icon>person</mat-icon>
              </div>
              <div class="menu-user-info">
                <span class="menu-user-name">{{ currentUser?.user?.username }}</span>
                <span class="menu-user-role">{{ currentUser?.user?.role?.name || 'User' }}</span>
              </div>
            </div>
            <mat-divider></mat-divider>
            <button mat-menu-item (click)="changePassword()">
              <mat-icon>lock</mat-icon>
              <span>Change Password</span>
            </button>
            <button mat-menu-item class="logout-btn" (click)="logout()">
              <mat-icon>logout</mat-icon>
              <span>Logout</span>
            </button>
          </mat-menu>
        </div>
      </mat-toolbar>
  
      <div class="container" #scrollContainer>
        <app-breadcrumb></app-breadcrumb>
        <div class="route-container">
          <router-outlet></router-outlet>
        </div>
      </div>
      
      <!-- Help Drawer (button is in toolbar) -->
      <app-help-drawer></app-help-drawer>
    </mat-sidenav-content>
  </mat-sidenav-container>